<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-logo">
          <h2>FASA <span>Transport</span></h2>
          <p>Supply of all building material countrywide. <br>You require we deliver</p>
        </div>
        
        <div class="footer-links">
          <div class="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/about">About Us</router-link></li>
              <li><router-link to="/services">Services</router-link></li>
              <li><router-link to="/contact">Contact</router-link></li>
            </ul>
          </div>
          
          <div class="footer-section">
            <h4>Services</h4>
            <ul>
              <li>Bulk Material Transport</li>
              <li>Heavy Equipment Delivery</li>
              <li>Scheduled Deliveries</li>
            </ul>
          </div>
          
          <div class="footer-section">
            <h4>Contact Info</h4>
            <p><i class="fas fa-map-marker-alt"></i> Nairobi, Kenya</p>
            <p><i class="fas fa-phone"></i> +254 1321 9273</p>
            <p><i class="fas fa-envelope"></i> gacherunancy@gmail.com</p>
          </div>
        </div>
      </div>
      
      <!-- <div class="footer-bottom">
        <p>&copy; {{ new Date().getFullYear() }} FASA Transport. All rights reserved.</p>
        <div class="social-icons">
          <a href="#" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
          <a href="#" aria-label="Twitter"><i class="fab fa-twitter"></i></a>
          <a href="#" aria-label="LinkedIn"><i class="fab fa-linkedin-in"></i></a>
          <a href="#" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
        </div>
      </div> -->
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: var(--secondary-color);
  color: white;
  padding: 60px 0 20px;
  
  .footer-content {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 50px;
    margin-bottom: 40px;
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  
  .footer-logo {
    h2 {
      font-size: 24px;
      margin-bottom: 15px;
      
      span {
        color: var(--primary-color);
      }
    }
    
    p {
      font-size: 14px;
      max-width: 250px;
    }
  }
  
  .footer-links {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    
    @media (max-width: 576px) {
      grid-template-columns: 1fr;
    }
  }
  
  .footer-section {
    h4 {
      font-size: 18px;
      margin-bottom: 20px;
      color: var(--primary-color);
    }
    
    ul {
      list-style: none;
      padding: 0;
      
      li {
        margin-bottom: 10px;
        
        a {
          color: white;
          text-decoration: none;
          transition: all 0.3s ease;
          
          &:hover {
            color: var(--primary-color);
          }
        }
      }
    }
    
    p {
      margin-bottom: 10px;
      
      i {
        margin-right: 10px;
        color: var(--primary-color);
      }
    }
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255,255,255,0.1);
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    @media (max-width: 576px) {
      flex-direction: column;
      text-align: center;
    }
    
    p {
      font-size: 14px;
    }
    
    .social-icons {
      display: flex;
      gap: 15px;
      
      @media (max-width: 576px) {
        margin-top: 15px;
      }
      
      a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: rgba(255,255,255,0.1);
        color: white;
        text-decoration: none;
        transition: all 0.3s ease;
        
        &:hover {
          background-color: var(--primary-color);
          transform: translateY(-3px);
        }
      }
    }
  }
}
</style>